import SubscriptionPlan from "../components/SubscriptionPlan";
import React, {useEffect, useState} from "react";
import {Alert, Container, Snackbar} from "@mui/material";
import {useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";

const Subscription: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const {t} = useTranslation();
    const [alert, setAlert] = useState<{ show: boolean; message: string; severity: 'success' | 'info' | 'error' }>({
        show: false,
        message: '',
        severity: 'success',
    });

    useEffect(() => {
        const status = searchParams.get('status');
        if (status) {
            let message = '';
            let severity: 'success' | 'info' | 'error' = 'success';

            switch (status) {
                case 'activated':
                    message = t('subscription.paymentSuccess');
                    severity = 'success';
                    break;
                case 'pending':
                    message = t('subscription.paymentPending');
                    severity = 'info';
                    break;
                case 'error':
                    message = t('subscription.paymentError');
                    severity = 'error';
                    break;
            }

            if (message) {
                setAlert({show: true, message, severity});
            }
            setSearchParams({}, {replace: true});
        }
    }, [searchParams, setSearchParams, t]);

    return (
        <Container maxWidth="lg">
            <SubscriptionPlan/>
            <Snackbar
                open={alert.show}
                autoHideDuration={6000}
                onClose={() => setAlert(prev => ({...prev, show: false}))}
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
            >
                <Alert
                    onClose={() => setAlert(prev => ({...prev, show: false}))}
                    severity={alert.severity}
                    sx={{width: '100%'}}
                >
                    {alert.message}
                </Alert>
            </Snackbar>
        </Container>
    );
};

export default Subscription;
